export default "__VITE_ASSET__BoB5842y__"